import cx from "classnames";
import { CoreLink } from "common/CoreLink";
import React, { Fragment } from "react";
import styles from "./DashboardElements.scss";

export const CardSectionHeading = ({ children, className, ...props }) => (
  <h2 {...props} data-heading-alt className={cx(styles.CardSectionHeading, className)}>
    {children}
  </h2>
);

export const MiniListItem = ({ to, href, title, left, children, className, ...props }) => {
  const C = to || href ? CoreLink : "div";

  const inner = (
    <Fragment>
      <div className={styles.title}>{title}</div>
      {children}
    </Fragment>
  );

  return (
    <C {...props} className={cx(styles.MiniListItem, className)} href={href} to={to}>
      {left ? (
        <div className={styles.flex}>
          <div className={styles.left}>{left}</div>
          <div className={styles.right}>{inner}</div>
        </div>
      ) : (
        inner
      )}
    </C>
  );
};

export const MiniListItemDetail = ({ children, className, ...props }) => (
  <div {...props} className={cx(styles.MiniListItemDetail, className)}>
    {children}
  </div>
);
